export enum ProfileType {
    player = 'player',
    coach = 'coach',
    team = 'team'
}
